import $ from 'jquery';

$(document).ready(function() {
	$(document).on('click', '.js-modal-review-rating-button', function() {
		$('.js-modal-review-rating-button').removeClass('active');
		$(this).addClass('active');
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/reviews/modal-review-rating.js